import { createContext, PropsWithChildren, useContext, useMemo } from 'react';

export type ClinicalCaseContextValue = {
  isScs: boolean;
};

const ClinicalCaseContext = createContext<ClinicalCaseContextValue>({ isScs: false });

export const ClinicalCaseProvider = ({ isScs = false, children }: PropsWithChildren<{ isScs?: boolean }>) => {
  const value = useMemo(() => ({ isScs }), [isScs]);
  return <ClinicalCaseContext.Provider value={value}>{children}</ClinicalCaseContext.Provider>;
};

export const useClinicalCaseContext = () => useContext(ClinicalCaseContext);
